import React from "react";
import { Container, Box, IconButton, Grid } from "@mui/material";
import { YouTube, Instagram, Facebook } from "@mui/icons-material";
import { ReactComponent as TikTokIcon } from "../assets/tiktok.svg"; // Importa el ícono de TikTok

const Footer = () => {
  const iconStyle = { width: 32, height: 32, color: "#000" }; // Define el estilo común para los íconos

  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        textAlign: "center",
        maxHeight: "20vh",
        backgroundColor: "#D29B07",
        position: 'relative'
      }}
    >
      <Container>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Box>&copy; {new Date().getFullYear()} Crispin Mateos Mateos</Box>
          </Grid>
          <Grid item>
            <IconButton
              href="https://www.youtube.com/channel/UCFaKT2eaLumXb4lHz3tllMw"
              target="_blank"
              aria-label="YouTube"
            >
              <YouTube style={iconStyle} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              href="https://www.instagram.com/lospolloshermanospop/"
              target="_blank"
              aria-label="Instagram"
            >
              <Instagram style={iconStyle} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              href="https://www.tiktok.com/@lospolloshermanostiktok"
              target="_blank"
              aria-label="TikTok"
            >
              <TikTokIcon style={iconStyle} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              href="https://www.facebook.com/crispinpop"
              target="_blank"
              aria-label="Facebook"
            >
              <Facebook style={iconStyle} />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          p: 5,
        }}
      >
        <img src="http://wsc.webaporter.com:80/cgi-bin/counter.PicCount?userid=AAS340INZ8PU&amp;bgc=4A2F10&amp;fgc=E9A259&amp;fn=ITC+Cheltenham+Bold+Italic&amp;fs=16&amp;fs=14&amp;digits=7&amp;gif=yes&amp;type=ledstd" alt="Counter" />
      </Box>
    </Box>
  );
};

export default Footer;
